import React from 'react'
import RoomGrid from './RoomGrid/RoomGrid'

import { useRoomViewLogic } from './RoomView.logic'
import WaitingRoom from './WaitingRoom/WaitingRoom'
import {
  ErrorBox,
  ErrorMessage,
  RoomsLayoutContainer,
  LoadingBox,
  LoadingTitle,
  RoomViewContainer,
  StyledCircularProgress,
  StyledMenuButton,
  ToggleIcon,
  TopToggleButton,
} from './RoomView.styles'
import DischargedPatientsModal from './DischargedPatientsModal/DischargedPatientsModal'

const RoomView: React.FC = () => {
  const logic = useRoomViewLogic()

  if (logic.isLoading)
    return (
      <LoadingBox>
        <LoadingTitle>Loading Room View...</LoadingTitle>
        <StyledCircularProgress />
      </LoadingBox>
    )

  if (logic.error)
    return (
      <ErrorBox>
        <ErrorMessage variant="h6" color="error">
          Error: {logic.error}
        </ErrorMessage>
      </ErrorBox>
    )

  return (
    <>
      <RoomViewContainer $isWaitingRoomHidden={logic.isWaitingRoomHidden}>
        <WaitingRoom
          isHidden={logic.isWaitingRoomHidden}
          setIsHidden={logic.setIsWaitingRoomHidden}
        />
        <RoomsLayoutContainer>
          <RoomGrid />
          <DischargedPatientsModal
            open={logic.dischargedPatientsModalOpen}
            onClose={() => logic.setDischargedPatientsModalOpen(false)}
          />
        </RoomsLayoutContainer>
      </RoomViewContainer>

      <StyledMenuButton
        variant="contained"
        size="small"
        onClick={() => {
          logic.setDischargedPatientsModalOpen(true)
        }}
      >
        DISCHARGED PATIENTS
      </StyledMenuButton>

      {logic.isWaitingRoomHidden && (
        <TopToggleButton onClick={() => logic.setIsWaitingRoomHidden(false)}>
          <ToggleIcon />
        </TopToggleButton>
      )}
    </>
  )
}

export default RoomView
